import { Component, OnInit, OnDestroy } from '@angular/core';
import { TokenStorageService } from '../../../services/token-storage/token-storage.service';
import { ProfileService } from '../../../services/profile/profile.service';
import { takeUntil, Subject } from 'rxjs';
import { User } from '../../../models/user';
import { ChangePasswordComponent } from '../../../change-password/change-password.component';
import { MatDialog } from '@angular/material/dialog';
import { BasicProfileComponent } from '../../../basic-profile/basic-profile.component';
import { ApplicationService } from '../../../services/application.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: []
})
export class AppHeaderComponent implements OnInit, OnDestroy {
  imgSrc = '';
  onDestroy$ = new Subject<void>();
  constructor(public tokenStorageService: TokenStorageService,
    private profileService: ProfileService,
    private applicationService: ApplicationService,
    private dialog: MatDialog) { }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
  ngOnInit(): void {
    const user: User = this.tokenStorageService.getUser();
    if (this.applicationService.profilePicture) {
      this.imgSrc = this.applicationService.profilePicture;
    } else {
      this.imgSrc = '/assets/images/users/' + (user.gender?.id === 1 ? 'male-pp.jpg' : 'female-pp.jpg');
    }
  }
  public openChangePasswordDialog() {
    this.dialog.open(ChangePasswordComponent, {
      disableClose: true,
    });
  }

  public openUpdateProfileDialog() {
    this.dialog.open(BasicProfileComponent, {
      disableClose: true,
    });
  }
}
